import * as React from "react"
import {User} from '../../../types/types'

export const FooterMenu = (
  props: {
    title:string,
    items:{title:string, url:string}[]
  }
) => (
  <ul className="footer__menu">
    <li className="footer__menu-title">{props.title}</li>
    {props.items.map(item => (
      <li key={item.title} className="footer__menu-item">
        <a className="footer__link" href={item.url}>
          {item.title}
        </a>
      </li>
    ))}
  </ul>
);

export const FooterMenuLanguage = (
  props: {
    title:string,
    class?:string,
    items:{title:string, url:string}[]
  }
) => (
  <ul className="footer__menu footer__menu--language">
    <li className="footer__menu-title">{props.title}</li>
    {props.items.map(item => (
      <li key={item.title} className="footer__menu-item">
        <a className="footer__link" href={item.url}>
          {item.title}
        </a>
      </li>
    ))}
  </ul>
);
